// const baseUrl = "https://sportingbharat.com/lmp-dev/dev/backend/api";
const baseUrl = "https://sah.sportzvillage.com/dev/backend/api";

export default baseUrl;